import { Box, Button, Heading, Stack, Text } from '@chakra-ui/react';
import { useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth.js';
import { brand, msalClientId, authDisabled } from '../lib/env.js';

export function Login() {
  const { isAuthenticated, login } = useAuth();
  const location = useLocation();
  const [error, setError] = useState<string>();
  const from =
    (location.state as { from?: { pathname: string } } | null)?.from?.pathname ?? '/orders';

  if (isAuthenticated) {
    return <Navigate to={from} replace />;
  }

  const configured = authDisabled || msalClientId !== '';

  return (
    <Box maxW="md" mx="auto" mt={16} p={8} bg="white" borderRadius="lg" boxShadow="md">
      <Stack gap={5} align="center">
        <Heading size="lg">Sign in</Heading>
        <Text color="fg.muted" textAlign="center">
          Sign in with your {brand.name} Microsoft account to manage orders and product data.
        </Text>
        {!configured && (
          <Text color="red.500" fontSize="sm" textAlign="center" data-name="msal-unconfigured">
            VITE_MSAL_CLIENT_ID is not set — configure the Entra app registration first (see
            docs/entra.md), or run the dev server with VITE_AUTH_MODE=disabled.
          </Text>
        )}
        {error && (
          <Text color="red.500" fontSize="sm" data-name="login-error">
            {error}
          </Text>
        )}
        <Button
          colorPalette="brand"
          size="lg"
          disabled={!configured}
          data-name="sign-in"
          onClick={() => {
            setError(undefined);
            login().catch((cause: unknown) => setError((cause as Error).message));
          }}
        >
          Sign in with Microsoft
        </Button>
      </Stack>
    </Box>
  );
}
